// extracted by mini-css-extract-plugin
export var button = "language-select-module--button--Mr70i";
export var dropdown = "language-select-module--dropdown--dNIDP";
export var flag = "language-select-module--flag--vwTS2";
export var iconBox = "language-select-module--icon-box--cy2y9";
export var open = "language-select-module--open--ZH2+2";